import React, {FC} from 'react';
import {DataGrid, GridColDef, GridFilterItem,} from "@material-ui/data-grid";
import {FeWorker} from "../redux/types";
import {WorkersReloadButton} from "./WorkersReloadButton";
import {WorkerMoreMenu} from "./WorkerMoreMenu";
import {ServiceChips} from "../../services/components/ServiceChip";
import {StatusDisplay} from "../../../sharedComponents/StatusIcon";
import {useHistory} from "react-router-dom";
import {Typography} from '@material-ui/core';
import {Address} from '../../../redux/types';
import {ServiceGridFilterInput} from "../../services/components/ServicesAutoComplete";
import {tableLocalizations} from "../../../sharedComponents/tableLocalizations";
import {getFullName} from "../../../utils";
import {TableToolbar} from "../../../sharedComponents/TableToolbar";
import {FeOrder} from "../../orders/redux/types";
import {store} from "../../../redux/store";
import {selectServiceById} from "../../services/redux/services.slice";

const columns: GridColDef[] = [
    {
        field: 'id',
        hide: true
    },
    {
        field: 'menu',
        disableColumnMenu: true,
        editable: false,
        resizable: false,
        flex: 0.15,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        renderHeader: () => <WorkersReloadButton/>,
        renderCell: (params) => <WorkerMoreMenu id={params.id}/>
    },
    {
        field: 'active',
        headerName: 'Status',
        editable: false,
        filterable: true,
        width: 150,
        type: "boolean",
        valueFormatter: (params) => params.value === true ? "Aktiv" : "Inaktiv",
        renderCell: ({value}) => (
            <div style={{display: 'flex', flex: 1}}>
                <StatusDisplay active={Boolean(value)}/>
            </div>
        )
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 240,
        valueGetter: (params) => getFullName(params.row as FeWorker),
        renderCell: (params) => getFullName(params.row as FeWorker)
    },
    {
        hide: true,
        field: 'salutation',
        headerName: 'Anrede',
        width: 122
    },
    {
        hide: true,
        field: 'firstName',
        headerName: 'Vorname',
        width: 150
    },
    {
        hide: true,
        field: 'lastName',
        headerName: 'Nachname',
        width: 150
    },
    {
        field: 'email',
        filterable: true,
        headerName: 'Email',
        width: 260
    },
    {
        hide: true,
        filterable: true,
        field: 'phone',
        headerName: 'Telefon',
        flex: 0.5
    },
    {
        hide: true,
        filterable: true,
        field: 'address',
        headerName: 'Addresse',
        flex: 1,
        valueFormatter: (params) => (params.value as Address).formattedAddress,
        renderCell: ((params) => (
            <Typography variant="inherit">
                {(params.value as Address)?.formattedAddress ?? ''}
            </Typography>)),
    },
    {
        field: 'servicesIds',
        filterable: true,
        headerName: 'Services',
        flex: 1,
        valueFormatter: (params) => {
            const order = params.row as FeOrder;
            const state = store.getState();
            return order.servicesIds.map(sId => {
                const service = selectServiceById(state, sId);
                return service?.name ?? ""
            }).join(", ")
        },
        filterOperators: [
            {
                label: "kann",
                value: "servicesIds",
                getApplyFilterFn: (filterItem: GridFilterItem) => {
                    if (
                        !filterItem.columnField ||
                        !filterItem.value ||
                        !filterItem.operatorValue
                    ) {
                        return null;
                    }

                    return (params): boolean => {
                        const workerServiceIds = params.value as string[];
                        const searchedServicesIds = filterItem.value as string[];
                        return searchedServicesIds.every((ssId) => workerServiceIds.includes(ssId))
                    };
                },
                InputComponent: ServiceGridFilterInput,
            }
        ],
        renderCell: (params) => (
            <ServiceChips
                serviceIds={params.value as string[]}
                initialAmount={4}
            />
        )
    },
    {
        hide: true,
        width: 150,
        field: 'hourlyWage',
        headerName: 'Stundenlohn'
    },
    {
        hide: true,
        width: 150,
        field: 'maxKmToOrder',
        headerName: 'Arbeitsweg'
    },
]

export const WorkersTable: FC<{ workers: FeWorker[], loading: boolean }> = ({workers, loading}) => {
    const history = useHistory();
    return (
        <div style={{height: 710, width: '100%'}}>
            <DataGrid
                localeText={tableLocalizations}
                components={{
                    Toolbar: TableToolbar
                }}
                onRowClick={(param) => history.push(`/admin/workers/worker/${param.id}`)}
                loading={loading}
                rows={workers}
                disableMultipleSelection={true}
                columns={columns}
                isCellEditable={() => false}
                pageSize={10}
                checkboxSelection={false}
                disableSelectionOnClick
            />
        </div>
    )
}
